// -----------------------------------------------------------------------------
// MAIN JAVASCRIPT FILE
// Theme initialization - simple and organized
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// CORE MODULES
// Essential theme functionality
// -----------------------------------------------------------------------------
import { initNavigation } from "./theme/_menu";
import "../blocks/_blocks.js";

// -----------------------------------------------------------------------------
// THEME FEATURES
// Import and organize theme functionality
// -----------------------------------------------------------------------------
import { initBannerSlider } from "./theme/_banners";
import { stickyHeader, stickySidebar } from "./theme/_header";
import { siteSearch } from "./theme/_search";
import { fadeAnimations } from "./theme/_animations";
import { openExternalLinks, scrollToPageTop, disclaimerPopup, lightbox } from "./theme/_base.js";
import { initWooVariations } from "./theme/_woocommerce";

// -----------------------------------------------------------------------------
// INITIALIZATION FUNCTIONS
// Group related functionality for clarity
// -----------------------------------------------------------------------------
const initBaseFeatures = () => {
  initNavigation(); // Initialize menu and navigation
  openExternalLinks(); // Handle external links and PDFs
  siteSearch(); // Initialize search functionality
  stickySidebar(); // Setup sticky sidebar behavior
};

const initInteractiveFeatures = () => {
  initBannerIfExists(); // Banner slideshow (conditional)
  fadeAnimations(); // Scroll animations
  lightbox(); // Gallery lightbox
  disclaimerPopup(); // Disclaimer modal
};

const initBannerIfExists = () => {
  const slides = document.querySelector(".banner-slideshow");
  if (!slides) return;

  const bannerOptions = {
    loop: slides.dataset.loop ? true : false,
    draggable: slides.dataset.draggable ? true : false,
    autoplay: slides.dataset.autoplay ? true : false,
    speed: slides.dataset.autoplay ? slides.dataset.speed : 4000,
    pause: slides.dataset.pause ? true : false
  };

  initBannerSlider(".banner-slideshow", bannerOptions);
};

// -----------------------------------------------------------------------------
// DOM READY: INITIALIZE ALL THEME FEATURES
// -----------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  initBaseFeatures(); // Core utility functions
  initInteractiveFeatures(); // Interactive elements
  initWooVariations();
});

// -----------------------------------------------------------------------------
// WINDOW SCROLL: HANDLE SCROLL-BASED FEATURES
// -----------------------------------------------------------------------------
window.addEventListener("scroll", function () {
  stickyHeader(); // Update header positioning

  // Conditional scroll features
  if (document.querySelector(".cd-top")) {
    scrollToPageTop();
  }
});
